import { MaterialReactTable } from "material-react-table";
import { BillsColumns } from "./constants/CustomerTableColumns";
import { Card ,Button, CardBody, Row} from "reactstrap";
export default function Bills({billData}) {
  const columns = BillsColumns(billData);
  return (
    <div className="border rounded-1 px-4 py-3 my-2 bg-white h-100">
    <CardBody>
      <Row className="table-responsive">
        {billData.length>0?
      <MaterialReactTable
        columns={columns}
        data={billData}
        muiTablePaperProps={{
          elevation: 0,
        }}
        defaultColumn={{
          minSize: 10,
          maxSize: 9001,
          muiTableBodyCellProps: {
              sx: {
                  fontFamily: "Inter,sans-serif"
              }
          },
          muiTableHeadCellProps: {
              sx: {
                  fontFamily: "Inter,sans-serif"
              }
          }
      }}
        enableBottomToolbar={false}
        enableColumnActions={true}
        enableDensityToggle={false}
        enablePagination={false}
        renderTopToolbar={false}
      />
      : (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
          No record to display
        </div>
      )}
    </Row>
     </CardBody>
    </div>
  );
}
